import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { EstadisticaDiaria } from '../../types'

interface StatsChartProps {
  data: EstadisticaDiaria[]
}

export function StatsChart({ data }: StatsChartProps) {
  return (
    <Card className="border border-gray-300 dark:border-gray-700">
      <CardHeader>
        <CardTitle className="text-lg">Estadísticas diarias (últimos 30 días)</CardTitle>
      </CardHeader>
      <CardContent>
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="fecha"
                tick={{ fontSize: 12 }}
                tickFormatter={(v) => {
                  const d = new Date(v)
                  return `${d.getDate()}/${d.getMonth() + 1}`
                }}
              />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                labelFormatter={(v) => {
                  const d = new Date(v as string)
                  return d.toLocaleDateString('es-EC')
                }}
              />
              <Legend />
              <Line type="monotone" dataKey="vistas" name="Vistas" stroke="#57a6d8" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="inicios" name="Inicios" stroke="#f6c23e" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="terminados" name="Terminados" stroke="#2fbc80" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="text-center py-12 text-muted-foreground">
            No hay datos suficientes para mostrar el gráfico
          </div>
        )}
      </CardContent>
    </Card>
  )
}
